import { useState } from "react";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import ProblemSection from "@/components/ProblemSection";
import ApproachSection from "@/components/ApproachSection";
import IndustriesSection from "@/components/IndustriesSection";
import ComplianceSection from "@/components/ComplianceSection";
import ProcessSection from "@/components/ProcessSection";
import CustomizationSection from "@/components/CustomizationSection";
import CTASection from "@/components/CTASection";
import Footer from "@/components/Footer";
import ContactModal from "@/components/ContactModal";

const LandingPage = () => {
  const [isContactOpen, setIsContactOpen] = useState(false);

  const openContact = () => setIsContactOpen(true);
  const closeContact = () => setIsContactOpen(false);

  return (
    <div className="min-h-screen bg-black">
      <Header onContactClick={openContact} />
      
      <main>
        <HeroSection onContactClick={openContact} />
        <ProblemSection />
        <ApproachSection />
        <IndustriesSection />
        <ComplianceSection />
        <ProcessSection />
        <CustomizationSection />
        <CTASection onContactClick={openContact} />
      </main>
      
      <Footer />
      
      <ContactModal isOpen={isContactOpen} onClose={closeContact} />
    </div>
  );
};

export default LandingPage;
